import { GetInferredFromRaw } from '@thinknimble/tn-models'
import { z } from 'zod'

export const memberShape = {
  id: z.string().uuid(),
  userId: z.string().uuid(),
  email: z.string().email(),
  firstName: z.string(),
  lastName: z.string(),
  roleName: z.string(),
  roleDisplayName: z.string(),
}

export const inviteMemberShape = {
  email: z.string().email(),
  role: z.string(),
}

export const updateMemberRoleShape = {
  role: z.string(),
}

export const roleShape = {
  id: z.string().uuid(),
  name: z.string(),
  displayName: z.string(),
  isDefault: z.boolean(),
  permissions: z.array(z.string()),
}

export const createRoleShape = {
  name: z.string(),
  displayName: z.string(),
  permissions: z.array(z.string()),
}

export const updateRoleShape = {
  name: z.string().optional(),
  displayName: z.string().optional(),
  permissions: z.array(z.string()).optional(),
}

export type Member = GetInferredFromRaw<typeof memberShape>
export type InviteMember = GetInferredFromRaw<typeof inviteMemberShape>
export type UpdateMemberRole = GetInferredFromRaw<typeof updateMemberRoleShape>
export type Role = GetInferredFromRaw<typeof roleShape>
export type CreateRole = GetInferredFromRaw<typeof createRoleShape>
export type UpdateRole = GetInferredFromRaw<typeof updateRoleShape>
